import { DateInput, FormItem } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.DateRange}`;

export interface IDateRangeRuleComponentProps {}

export function DateRangeRuleComponent(props: IDateRangeRuleComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.fromDate`}
        label="Dal"
        help="La data si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <DateInput name={`${fieldName}.fromDate`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.toDate`}
        label="Al"
        help="La data si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <DateInput name={`${fieldName}.toDate`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
